export const PATIENT_PROFILE_ROUTES = {
  PERSONAL_INFO: 'personal-info',
  ACCOUNT_SECURITY: 'account-security',
  CONTACT_INFO: 'contact-info',
  HEALTH_QUESTIONNAIRE: 'health-questionnaire',
  MY_PHARMACY: 'my-pharmacy',
  MY_MEDIA_LIBRARY: 'my-media-library',
  MY_MEDICAL_RECORDS: 'medical-records',
  MY_RECEIPTS_HISTORY: 'receipts-history',
  MY_MESSAGES: 'my-messages',
  MY_ORDERS: 'orders',
  MY_NOTIFICATIONS_SETTINGS: 'notifications-settings',
  MY_CLOSED_CHILDREN: 'closed-children',
  APP_TOUR: 'app-tour',
  BILLING_SERVICE: 'billing-service',
  LEGAL_DOCS: 'legal-documents',
};
